<template>
  <div class="page">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据编号</label>
            <em class="weui-form-preview__value">{{form.main.ms_code}}</em>
          </div>
        </div>
        <custom-layout class="weui-form-preview__bd" :view-config="customViewConfig">
          <div class="weui-form-preview__item" slot="ms_vendname">
            <label class="weui-form-preview__label">{{customLabel.ms_vendname || "外协厂商"}}</label>
            <em class="weui-form-preview__value">{{form.main.ms_vendname}}</em>
          </div>
          <div class="weui-form-preview__item" slot="createTime">
            <label class="weui-form-preview__label">{{customLabel.createTime || "报废日期"}}</label>
            <span class="weui-form-preview__value">{{form.main.createTime}}</span>
          </div>
        </custom-layout>
      </div>

      <div class="form-preview weui-form-preview">
        <div
          class="weui-form-preview__bd form-detail-preview"
          v-for="item in form.items"
          :key="item.id"
        >
          <div class="form-detail-preview_num">{{item.md_detno}}</div>
          <custom-layout :view-config="customViewConfig" position="detail1">
          <div class="weui-form-preview__item" slot="md_macode">
            <label class="weui-form-preview__label">{{customLabel.md_macode || "外协单"}}</label>
            <span class="weui-form-preview__value">{{item.md_macode}} 序号 {{item.md_mmdetno}}</span>
          </div>
          <div class="weui-form-preview__item" slot="pr_detail">
            <label class="weui-form-preview__label">{{customLabel.pr_detail || "产品"}}</label>
            <span
              class="weui-form-preview__value"
            >{{item.md_prodcode}} {{item.productDTO.pr_detail}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="item.productDTO.pr_brand" slot="pr_brand">
            <label class="weui-form-preview__label">{{customLabel.pr_brand || "品牌"}}</label>
            <span class="weui-form-preview__value">{{item.productDTO.pr_brand}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="item.productDTO.pr_orispeccode" slot="pr_orispeccode">
            <label class="weui-form-preview__label">{{customLabel.pr_orispeccode || "型号"}}</label>
            <span class="weui-form-preview__value">{{item.productDTO.pr_orispeccode}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="item.productDTO.pr_spec" slot="pr_spec">
            <label class="weui-form-preview__label">{{customLabel.pr_spec || "规格"}}</label>
            <span class="weui-form-preview__value">{{item.productDTO.pr_spec}}</span>
          </div>
          <div class="weui-form-preview__item" slot="md_qty">
            <label class="weui-form-preview__label">{{customLabel.md_qty || "报废数量"}}</label>
            <span class="weui-form-preview__value">
              <span>{{numberFormat(item.md_qty,'#,##0.#')}}</span>
              &nbsp;{{item.productDTO.pr_unit}}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="qty" v-if="item.qty">
            <label class="weui-form-preview__label">{{
              customLabel.qty || "辅助数量"
            }}</label>
            <span class="weui-form-preview__value"
              >{{ item.qty }} {{ item.productDTO.pr_unit_extra }}</span
            >
          </div>
          <div class="weui-form-preview__item" slot="md_reason">
            <label class="weui-form-preview__label">{{customLabel.md_reason || "报废原因"}}</label>
            <span class="weui-form-preview__value">{{item.md_reason}}</span>
          </div>
          <div class="weui-form-preview__item" slot="md_price">
            <label class="weui-form-preview__label">{{customLabel.md_price || "成本单价(元)"}}</label>
            <span class="weui-form-preview__value">{{numberFormat(item.md_price,'#,##0.####')}}</span>
          </div>
          <div class="weui-form-preview__item" slot="md_total">
            <label class="weui-form-preview__label">{{customLabel.md_total || "金额(元)"}}</label>
            <span class="weui-form-preview__value">{{numberFormat(item.md_total,'#,##0.00')}}</span>
          </div>
          </custom-layout>
        </div>
      </div>

      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">金额合计（元）</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{form.main.ms_total}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import form from "@/mixins/form.js";

export default {
  mixins: [form],
    components: {
    CustomLayout,
  },
  data() {
    return {
      baseUrl: "/api/make/makescrap",
      caller: "OsMakeScrap",
      xtype: "osmake-osmakescrap-formpanel",
    };
  }
};
</script>